
import BButton from 'JS/components/BButton.vue';
import LoggerService from '../../services/LoggerService';
import ProductHelper from '../helpers/ProductHelper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FulfillmentType } from '../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from 'JS/types/LocalStore';
import { IProductDetailProductJson } from '../../types/PDP';
import { IProductGroupSelector, IProductGroupSelectorValue } from '../../types/Product';
import { ProductSubscriptionStatus } from 'JS/types/Order';

@Component({
	name: 'ProductCallToAction',
	components: {
		BButton
	}
})
export default class ProductCallToAction extends Vue {

	/* Props
	============================================*/
	@Prop({ type: Boolean })
	loading: boolean

	/* Computed
	============================================*/
	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('details')
	readonly details: any;

	@Get('quantity')
	readonly quantity: number;

	@Get('quantityExceedsStock')
	readonly quantityExceedsStock: boolean;

	@Get('quantityLessThanMin')
	readonly quantityLessThanMin: string | false;

	@Get('quantityOutsideInterval')
	readonly quantityOutsideInterval: string | false;

	@Get('quantityGreaterThanMax')
	readonly quantityGreaterThanMax: string | false;

	@Get('remainingSelectors')
	readonly remainingSelectors: any;

	@Get('outOfMarket')
	readonly outOfMarket: boolean;

	@Get('remainingVariants')
	readonly remainingVariants: any;

	@Get('productHasFulfillmentError')
	readonly productHasFulfillmentError: boolean;

	@Get('productHasStock')
	readonly productHasStock: boolean;

	@Get('fulfillmentType')
	readonly fulfillmentType: FulfillmentType;

	@Get('singleValueSelectors')
	readonly singleValueSelectors: IProductGroupSelector[];

	@Get('subscriptionFrequency')
	readonly subscriptionFrequency: number;

	@Get('selectedAttributes')
	readonly selectedAttributes: Record<string, IProductGroupSelectorValue>;

	@Get('shippingDeliveryDate')
	readonly shippingDeliveryDate: string;

	@Get('currentZip')
	readonly currentZip: string;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	get isDisabled(): boolean {
		return (
			(
				this.product.isSoldOut
				|| this.productHasFulfillmentError
				|| !this.productHasStock
				|| this.outOfMarket
				|| this.quantityExceedsStock
				|| this.quantityLessThanMin
				|| this.quantityOutsideInterval
				|| this.quantityGreaterThanMax
				|| this.quantity === 0
				|| (
					this.remainingVariants.length === 0
					&& this.singleValueSelectors.length === 0
					&& this.details.isGroup
				)
			)
			&& this.remainingSelectors.length === 0
		) ? true : false;
	}

	get ariaProductInfo(): string {
		if (this.remainingSelectors.length !== 0) return "You have attributes left to select.";
		if (this.remainingVariants.length === 0 && this.singleValueSelectors.length === 0 && this.details.isGroup) return "There are no products in stock with your selected attributes.";
		if (this.outOfMarket) return "Add a local store to purchase this item.";
		if (this.product.isSoldOut) return "This product is out of stock.";
		if (!this.productHasStock) return "This product is out of stock for " + this.fulfillmentHelper();
		if (this.quantityExceedsStock) return "Selected quantity exceeds what is in stock.";
		if (this.quantityLessThanMin) return this.quantityLessThanMin;
		if (this.quantityOutsideInterval) return this.quantityOutsideInterval;
		if (this.quantityGreaterThanMax) return this.quantityGreaterThanMax;
		if (this.productHasFulfillmentError) return "This product is not available for " + this.fulfillmentHelper();

		const attributes = Object.entries(this.selectedAttributes);
		let info = "Quantity: " + this.quantity + ", ";
		attributes.forEach(attr => info += attr[0] + ": " + attr[1] + ", ");
		info += this.product.name + " for ";

		if (this.fulfillmentType === FulfillmentType.StandardShipping) {
			info += "shipping";
		} else if (this.fulfillmentType === FulfillmentType.LocalDelivery) {
			info += "local delivery";
		} else {
			if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active) {
				if (this.product.subscriptionInfo.isDue) {
					info += "subscription refill pickup";
				} else {
					info += "a one time purchase subscription pickup";
				}
			} else if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Ineligible) {
				info += this.fulfillmentType;
			} else {
				if (this.subscriptionFrequency) {
					info += "a new subscription pickup, frequency: every " + (this.subscriptionFrequency <= 1 ? "week" : this.subscriptionFrequency + " weeks");
				} else {
					info += "a one time purchase pickup";
				}
			}
		}
		return info;
	}

	/* Data
	============================================*/
	readonly logger: LoggerService = new LoggerService();
	error: string =  null;

	/* Methods
	============================================*/

	fulfillmentHelper() {
		if (this.fulfillmentType === FulfillmentType.StandardShipping) return "shipping";
		if (this.fulfillmentType === FulfillmentType.LocalDelivery) return "local delivery";
		return this.fulfillmentType;
	}

	async doAction() {
		if (this.isDisabled) return;
		// Check for remaining selectors
		if (this.remainingSelectors.length) {
			this.error = ProductHelper.getRemainingSelectorsMessage(this.remainingSelectors);
			const remainingSelectors = ProductHelper.getRemainingSelectors(this.remainingSelectors);
			this.$store.dispatch('setSelectorError', remainingSelectors[0]);
			return;
		}

		// Adding custom event for tracking PDP add to cart
		window.blainGtmDataLayer.push({
			'event': "pdp_add_to_cart"
		});

		this.$emit('addToCart');
	}

	navigateToCheckout() {
		if (typeof window !== 'undefined') {
			window.location.href = "/cart/";
		}
	}

	handleError(err) {
		this.logger.log(err);
	}

	/* Lifecycle Hooks
	============================================*/

}
